import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import Categorys from '../Components/Category/Category'

function Category() {
    const [comp, setComp] = useState("list");
    const [rowData, setRowData] = useState();
    const location = useLocation();
  
    useEffect(() => {
      setComp("list");
    }, [location]);
  
    function handleChange(newValue) {
      setComp(newValue.mode);
      setRowData(newValue.rowData);
    }
    return <><Categorys/></>;
}

export default Category